// disOS sign-in / create-account. Open signup (anyone can make an account).
import { useState, type FormEvent } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/authStore';
import { ApiError } from '../api/client';
import { usePubBody } from './pubBody';
import './public.css';

export function AuthPage() {
  usePubBody();
  const nav = useNavigate();
  const login = useAuth((s) => s.login);
  const signup = useAuth((s) => s.signup);
  const [mode, setMode] = useState<'login' | 'signup'>('login');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    if (mode === 'signup' && password.length < 8) { setError('Password must be at least 8 characters.'); return; }
    setBusy(true);
    try {
      if (mode === 'signup') await signup(email, password);
      else await login(email, password);
      nav('/app', { replace: true });
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Something went wrong. Please try again.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="pub">
      <header className="nav">
        <div className="wrap">
          <Link className="brand" to="/"><span className="badge">dis</span><span className="wm">disOS</span></Link>
        </div>
      </header>

      <div className="authwrap">
        <div className="authcard">
          <div className="head">
            <span className="badge">dis</span>
            <h1>{mode === 'login' ? 'Sign in to disOS' : 'Create your disOS account'}</h1>
            <p>{mode === 'login' ? 'Welcome back.' : 'It only takes a moment.'}</p>
          </div>

          <form className="panel" onSubmit={onSubmit}>
            {error && <div className="err">{error}</div>}
            <div className="field">
              <label htmlFor="email">Email</label>
              <input id="email" type="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" required />
            </div>
            <div className="field">
              <label htmlFor="password">Password</label>
              <input id="password" type="password" autoComplete={mode === 'login' ? 'current-password' : 'new-password'} value={password} onChange={(e) => setPassword(e.target.value)} placeholder={mode === 'signup' ? 'At least 8 characters' : 'Your password'} required />
            </div>
            <button className="btn" type="submit" disabled={busy}>
              {busy ? 'Please wait…' : mode === 'login' ? 'Sign in' : 'Create account'}
            </button>
          </form>

          <div className="toggle">
            {mode === 'login'
              ? <>New to disOS? <button type="button" onClick={() => { setMode('signup'); setError(null); }}>Create an account</button></>
              : <>Already have an account? <button type="button" onClick={() => { setMode('login'); setError(null); }}>Sign in</button></>}
          </div>

          <div className="authfoot"><Link to="/">← Back to home</Link></div>
        </div>
      </div>
    </div>
  );
}
